/**
 * The compass band's four letters (ADR-061's amendment of 2026-10-14, "a square compass round the minimap", decision 3):
 * original art, 5 by 5 whole pixels, a `#` for a pixel drawn, in the weight of the pixel face and drawn by the canvas
 * painter (`compass.ts`) as `minimap-glyphs.ts` draws the star and the skull. North up, never rotating, so the four
 * letters are the only ones; the corners carry ticks, which are squares the painter draws.
 */

/**
 * The side of a letter in pixels.
 */
export const COMPASS_GLYPH_SIZE = 5;

/**
 * A letter the band carries.
 */
export type CompassLetter = "N" | "E" | "S" | "W";

/**
 * The letters' pixels, rows top to bottom.
 */
export const COMPASS_GLYPHS: Readonly<Record<CompassLetter, readonly string[]>> = Object.freeze({
  N: Object.freeze(["#...#", "##..#", "#.#.#", "#..##", "#...#"]),
  E: Object.freeze(["#####", "#....", "###..", "#....", "#####"]),
  S: Object.freeze([".####", "#....", ".###.", "....#", "####."]),
  W: Object.freeze(["#...#", "#...#", "#.#.#", "##.##", "#...#"]),
});
